/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.PriorityFeaturesRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getTranslatedPriorityFeaturesRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.PriorityFeaturesRpc',
  rpcName: 'getTranslatedPriorityFeatures',
  auth: 'external',
  fingerprint: 'M3RtdDWHlQovkoce7u9_LZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTranslatedPriorityFeaturesBulkRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.PriorityFeaturesRpc',
  rpcName: 'getTranslatedPriorityFeaturesBulk',
  auth: 'external',
  fingerprint: 'cA7-oI0JXguh-Q7BbC9b15wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};